const quoteStatus = {
    INVALID : 0,

    INVALID_RATING : 1,

    VALID_RATING : 2,

    INVALID_QUOTE : 3,

    VALID_QUOTE : 4,

    SENT : 5,

    QUOTED : 5,

    BIND_REQUESTED : 6,

    BIND_CONFIRMED : 7,

    BOUND : 7,

    WITHDRAWN : 8,

    SENT_AGAIN : 10,

    DECLINED : 13,

    PENDING_RATING : 14,

    BEGIN_BINDING : 15,

    AWAITING_RATE : 16,

    PENDING_BINDING : 18,

    VALID_BIND : 20,

    NOT_TAKEN : 22,

    BIND_REQUEST_STARTED : 23,

    REPLACED : 24,

    PRICED : 25,

    ENDORSEMENT_ISSUANCE : 26,

    POLICY_REWRITE_ISSUANCE : 27

};

angular.module('gw-um-j2js')
    .constant('quoteStatus', quoteStatus);